import StrikeZoneModelBase from '../classificators/strikeZoneModel/StrikeZoneModelBase.js';
import { Series } from '../entities/index.js';

const strikeZoneOutlineSeriesProvider = function(strikeZoneModel, fromPitchersPerspective) {
    if (!(strikeZoneModel instanceof StrikeZoneModelBase)){
        throw new TypeError('strikeZoneModel must extend StrikeZoneModelBase');
    }

    const xAxisInverter = fromPitchersPerspective ? -1: 1;

    const strikeZoneSeries = new Series('strikeZone', 2);
    // left bottom
    strikeZoneSeries.add(undefined, xAxisInverter * strikeZoneModel.getStrikeZoneLeft(), strikeZoneModel.getStrikeZoneBottom());
    // left top
    strikeZoneSeries.add(undefined, xAxisInverter * strikeZoneModel.getStrikeZoneLeft(), strikeZoneModel.getStrikeZoneTop());
    // right top
    strikeZoneSeries.add(undefined, xAxisInverter * strikeZoneModel.getStrikeZoneRight(), strikeZoneModel.getStrikeZoneTop());
    // right bottom
    strikeZoneSeries.add(undefined, xAxisInverter * strikeZoneModel.getStrikeZoneRight(), strikeZoneModel.getStrikeZoneBottom());
    // left bottom
    strikeZoneSeries.add(undefined, xAxisInverter * strikeZoneModel.getStrikeZoneLeft(), strikeZoneModel.getStrikeZoneBottom());

    return strikeZoneSeries;
};

export default strikeZoneOutlineSeriesProvider;